import { useState, useEffect } from "react";
import "../../../assets/css/student/leaderboard.css";
import MyStudentLayout from "../../../layouts/Student/MyStudentLayout";

// ─── SVG Icons ───────────────────────────────────────────────────────────────

const IconTrophy = () => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
    <path d="M9 12V15M6 17h6M4 2H2v3c0 2.2 1.8 4 4 4M14 2h2v3c0 2.2-1.8 4-4 4" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round"/>
    <path d="M6 2h6v5a3 3 0 01-6 0V2z" stroke="currentColor" strokeWidth="1.4" strokeLinejoin="round"/>
  </svg>
);

const IconZap = () => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
    <path d="M10.5 2L4 10.5h5.5L7.5 16 14 7.5H8.5L10.5 2z" stroke="currentColor" strokeWidth="1.4" strokeLinejoin="round"/>
  </svg>
);

const IconTrendUp = () => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
    <path d="M2 13l5-5 3.5 3.5L16 4" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M12 4h4v4" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const IconFlame = () => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
    <path d="M9 2c0 3-4 4.5-4 8a5 5 0 0010 0c0-3-2-4-2-6-1.5 1.5-1.5 3-2.5 3C9 7 10 4.5 9 2z" stroke="currentColor" strokeWidth="1.4" strokeLinejoin="round"/>
    <path d="M7.5 13.5a2 2 0 003 0" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round"/>
  </svg>
);

const IconArrowUp = () => (
  <svg width="13" height="13" viewBox="0 0 13 13" fill="none">
    <path d="M6.5 10V3M3 6.5L6.5 3 10 6.5" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const IconArrowDown = () => (
  <svg width="13" height="13" viewBox="0 0 13 13" fill="none">
    <path d="M6.5 3v7M3 6.5L6.5 10 10 6.5" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const IconChevronRight = () => (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
    <path d="M5 3l4 4-4 4" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const IconBrain = () => (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
    <path d="M7 1.5C5 1.5 3.5 3 3.5 4.8c0 .6.2 1.2.5 1.6-.3.4-.5.9-.5 1.5C3.5 9.5 4.6 11 6.5 11.3V13h1v-1.7c1.9-.3 3-1.8 3-3.4 0-.6-.2-1.1-.5-1.5.3-.4.5-1 .5-1.6C10.5 3 9 1.5 7 1.5z" stroke="currentColor" strokeWidth="1.2"/>
  </svg>
);

const IconTarget = () => (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
    <circle cx="7" cy="7" r="5.5" stroke="currentColor" strokeWidth="1.2"/>
    <circle cx="7" cy="7" r="3" stroke="currentColor" strokeWidth="1.2"/>
    <circle cx="7" cy="7" r=".8" fill="currentColor"/>
  </svg>
);

const IconCode = () => (
  <svg width="13" height="13" viewBox="0 0 13 13" fill="none">
    <path d="M4 3.5L1 6.5 4 9.5M9 3.5L12 6.5 9 9.5M7 2l-1 9" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const IconCrown = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path d="M2 12h12M2 12L4 5l4 3 4-5 2 7" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

// ─── Data ────────────────────────────────────────────────────────────────────

const USERS = [
  { id: 1, name: "Aisha Raza",      initials: "AR", xp: 12840, rank: 1,  prev: 1,  courses: 14, assignments: 87, accuracy: 96, streak: 42, badges: ["Top 1%", "Consistent"],      skills: { React: 94, JS: 91, AI: 78, Backend: 65, FullStack: 82 }, weeklyXP: 1240, growth: 8.4  },
  { id: 2, name: "Omar Farooq",     initials: "OF", xp: 11650, rank: 2,  prev: 4,  courses: 12, assignments: 79, accuracy: 94, streak: 31, badges: ["Fast Learner","AI Optimized"], skills: { React: 88, JS: 95, AI: 72, Backend: 70, FullStack: 79 }, weeklyXP: 1580, growth: 14.2 },
  { id: 3, name: "Sara Malik",      initials: "SM", xp: 10920, rank: 3,  prev: 2,  courses: 11, assignments: 82, accuracy: 92, streak: 28, badges: ["Consistent"],                skills: { React: 91, JS: 87, AI: 85, Backend: 60, FullStack: 88 }, weeklyXP: 890,  growth: 5.1  },
  { id: 4, name: "Hassan Ali",      initials: "HA", xp: 10340, rank: 4,  prev: 3,  courses: 13, assignments: 74, accuracy: 89, streak: 19, badges: ["Fast Learner"],               skills: { React: 80, JS: 85, AI: 91, Backend: 75, FullStack: 77 }, weeklyXP: 1120, growth: 12.3 },
  { id: 5, name: "Zara Khan",       initials: "ZK", xp: 9870,  rank: 5,  prev: 7,  courses: 10, assignments: 70, accuracy: 91, streak: 35, badges: ["AI Optimized"],              skills: { React: 76, JS: 82, AI: 88, Backend: 68, FullStack: 74 }, weeklyXP: 1380, growth: 16.2 },
  { id: 6, name: "Bilal Chaudhry", initials: "BC", xp: 9210,  rank: 6,  prev: 5,  courses: 9,  assignments: 68, accuracy: 88, streak: 14, badges: [],                            skills: { React: 85, JS: 79, AI: 65, Backend: 82, FullStack: 80 }, weeklyXP: 760,  growth: 3.8  },
  { id: 7, name: "Nadia Siddiqui", initials: "NS", xp: 8750,  rank: 7,  prev: 9,  courses: 8,  assignments: 65, accuracy: 87, streak: 22, badges: ["Consistent"],                skills: { React: 70, JS: 76, AI: 74, Backend: 90, FullStack: 71 }, weeklyXP: 980,  growth: 9.7  },
  { id: 8, name: "Usman Tariq",    initials: "UT", xp: 8320,  rank: 8,  prev: 6,  courses: 11, assignments: 60, accuracy: 85, streak: 10, badges: [],                            skills: { React: 78, JS: 80, AI: 60, Backend: 77, FullStack: 76 }, weeklyXP: 620,  growth: 2.1  },
];

const ME = {
  id: 9, name: "You", initials: "YO",
  xp: 7840, rank: 12, prev: 18,
  courses: 8, assignments: 55, accuracy: 83, streak: 16,
  badges: ["Fast Learner"],
  skills: { React: 72, JS: 75, AI: 68, Backend: 60, FullStack: 70 },
  weeklyXP: 1240, growth: 19.4,
  nextRankXP: 8320, currentRankXP: 7500,
};

const SKILLS     = ["React", "JavaScript", "AI / ML", "Backend", "Full Stack"];
const SKILL_KEYS = ["React", "JS", "AI", "Backend", "FullStack"];
const SKILL_COLORS = ["#8b5cf6", "#f59e0b", "#3b82f6", "#10b981", "var(--garnet)"];

const BADGE_CONFIG = {
  "Top 1%":      { color: "#d4a017", bg: "rgba(212,160,23,0.12)"  },
  "Fast Learner":{ color: "#10b981", bg: "rgba(16,185,129,0.12)"  },
  "Consistent":  { color: "#3b82f6", bg: "rgba(59,130,246,0.12)"  },
  "AI Optimized":{ color: "#8b5cf6", bg: "rgba(139,92,246,0.12)"  },
};

const MEDAL_COLORS = ["#d4a017", "#b0b0b0", "#c4773b"];

// ─── Hooks ───────────────────────────────────────────────────────────────────

function useCountUp(target, duration = 1200) {
  const [val, setVal] = useState(0);
  useEffect(() => {
    let start = null;
    const step = (ts) => {
      if (!start) start = ts;
      const p = Math.min((ts - start) / duration, 1);
      setVal(Math.floor(p * target));
      if (p < 1) requestAnimationFrame(step);
    };
    requestAnimationFrame(step);
  }, [target, duration]);
  return val;
}

// ─── Shared Components ────────────────────────────────────────────────────────

function SkillBar({ label, value, color }) {
  const [w, setW] = useState(0);
  useEffect(() => { const t = setTimeout(() => setW(value), 200); return () => clearTimeout(t); }, [value]);
  return (
    <div className="skill-bar-row">
      {label && <span className="skill-bar-label">{label}</span>}
      <div className="skill-bar-track">
        <div className="skill-bar-fill" style={{ width: `${w}%`, background: color, transition: "width .8s cubic-bezier(.4,0,.2,1)" }} />
      </div>
      <span className="skill-bar-val">{value}</span>
    </div>
  );
}

function Badge({ label }) {
  const cfg = BADGE_CONFIG[label] || { color: "#888", bg: "rgba(136,136,136,.1)" };
  return (
    <span className="badge" style={{ color: cfg.color, background: cfg.bg, borderColor: cfg.color + "33" }}>
      {label}
    </span>
  );
}

function RankChange({ curr, prev }) {
  const diff = prev - curr;
  if (diff === 0) return <span className="rank-same">—</span>;
  if (diff > 0)   return <span className="rank-up"><IconArrowUp />{diff}</span>;
  return              <span className="rank-down"><IconArrowDown />{Math.abs(diff)}</span>;
}

// ─── KPI Widget ───────────────────────────────────────────────────────────────
// Fix: always call useCountUp — pass 0 when animation not needed

function KPIWidget({ icon: Icon, label, value, sub, accent, animate }) {
  const numericTarget = animate && typeof value === "number" ? value : 0;
  const counted = useCountUp(numericTarget); // always called, no conditional hook

  const display = animate && typeof value === "number"
    ? counted.toLocaleString()
    : value;

  return (
    <div className="kpi-card" style={{ "--accent": accent }}>
      <div className="kpi-icon"><Icon /></div>
      <div className="kpi-body">
        <span className="kpi-val">{display}</span>
        <span className="kpi-label">{label}</span>
        {sub && <span className="kpi-sub">{sub}</span>}
      </div>
      <div className="kpi-glow" />
    </div>
  );
}

// ─── Leaderboard Row ──────────────────────────────────────────────────────────

function LeaderboardRow({ user, index, isMe }) {
  const [exp, setExp] = useState(false);
  const isTop3 = user.rank <= 3;

  return (
    <div
      className={`lb-row ${isMe ? "lb-row-me" : ""} ${exp ? "expanded" : ""}`}
      style={{ animationDelay: `${index * 60}ms` }}
      onClick={() => setExp(v => !v)}
    >
      <div className="lb-row-main">
        <div className="lb-rank-col">
          {isTop3 ? (
            <div className="lb-medal" style={{ color: MEDAL_COLORS[user.rank - 1] }}>
              {user.rank === 1 && <IconCrown />}
              <span className="lb-rank-num" style={{ color: MEDAL_COLORS[user.rank - 1] }}>#{user.rank}</span>
            </div>
          ) : (
            <span className="lb-rank-num">#{user.rank}</span>
          )}
        </div>
        <div className="lb-avatar" style={{ background: isMe ? "var(--garnet)" : `hsl(${user.id * 47}, 55%, 52%)` }}>
          {user.initials}
        </div>
        <div className="lb-identity">
          <span className="lb-name">{user.name}{isMe && <span className="me-tag">You</span>}</span>
          <div className="lb-badges">{user.badges.slice(0, 2).map(b => <Badge key={b} label={b} />)}</div>
        </div>
        <div className="lb-stat"><span className="ls-val">{user.xp.toLocaleString()}</span><span className="ls-lbl">XP</span></div>
        <div className="lb-stat"><span className="ls-val">{user.courses}</span><span className="ls-lbl">Courses</span></div>
        <div className="lb-stat"><span className="ls-val">{user.assignments}</span><span className="ls-lbl">Tasks</span></div>
        <div className="lb-stat">
          <span className="ls-val accuracy" style={{ color: user.accuracy >= 90 ? "#10b981" : user.accuracy >= 85 ? "#3b82f6" : "#f59e0b" }}>
            {user.accuracy}%
          </span>
          <span className="ls-lbl">Accuracy</span>
        </div>
        <div className="lb-stat"><RankChange curr={user.rank} prev={user.prev} /></div>
        <div className="lb-chevron"><IconChevronRight /></div>
      </div>

      {exp && (
        <div className="lb-row-expand">
          <div className="exp-skills">
            {SKILL_KEYS.map((sk, i) => (
              <SkillBar key={sk} label={SKILLS[i]} value={user.skills[sk]} color={SKILL_COLORS[i]} />
            ))}
          </div>
          <div className="exp-actions">
            <button className="exp-btn exp-btn-view">View Profile</button>
            <button className="exp-btn exp-btn-cmp">Compare Progress</button>
          </div>
        </div>
      )}
    </div>
  );
}

// ─── Global Ranking View ──────────────────────────────────────────────────────

function GlobalRankingView() {
  return (
    <div className="global-view">
      <div className="lb-header-row">
        <span style={{ width: 60 }}>Rank</span>
        <span style={{ flex: 1 }}>Student</span>
        <span style={{ width: 80 }}>XP</span>
        <span style={{ width: 70 }}>Courses</span>
        <span style={{ width: 70 }}>Tasks</span>
        <span style={{ width: 80 }}>Accuracy</span>
        <span style={{ width: 70 }}>Change</span>
        <span style={{ width: 28 }} />
      </div>
      <div className="lb-list">
        {USERS.map((u, i) => <LeaderboardRow key={u.id} user={u} index={i} />)}
        <div className="lb-divider"><span>Your Position</span></div>
        <LeaderboardRow user={ME} index={USERS.length} isMe />
      </div>
    </div>
  );
}

// ─── Skill Ranking View ───────────────────────────────────────────────────────

function SkillRankingView() {
  const [active, setActive] = useState(0);

  const getRanking = (skillKey) =>
    [...USERS]
      .sort((a, b) => b.skills[skillKey] - a.skills[skillKey])
      .map((u, i) => ({ ...u, skillRank: i + 1, skillScore: u.skills[skillKey] }));

  const ranked = getRanking(SKILL_KEYS[active]);

  return (
    <div className="skill-view">
      <div className="skill-filter-row">
        {SKILLS.map((s, i) => (
          <button key={s} className={`skill-filter-btn ${active === i ? "on" : ""}`} onClick={() => setActive(i)}>
            {s}
          </button>
        ))}
      </div>
      <div className="skill-table">
        {ranked.map((u, i) => (
          <div key={u.id} className="skill-row" style={{ animationDelay: `${i * 50}ms` }}>
            <span className="sk-rank" style={{ color: i < 3 ? MEDAL_COLORS[i] : "var(--ink-m)" }}>#{u.skillRank}</span>
            <div className="sk-avatar" style={{ background: `hsl(${u.id * 47}, 55%, 52%)` }}>{u.initials}</div>
            <span className="sk-name">{u.name}</span>
            <div className="sk-bar-wrap">
              <SkillBar value={u.skillScore} color={SKILL_COLORS[active]} />
            </div>
            <span className="sk-score">{u.skillScore}/100</span>
          </div>
        ))}
      </div>
    </div>
  );
}

// ─── Weekly Movers View ───────────────────────────────────────────────────────

function WeeklyMoversView() {
  const movers = [...USERS, ME].sort((a, b) => b.growth - a.growth);

  return (
    <div className="movers-view">
      <div className="movers-grid">
        {movers.map((u, i) => (
          <div key={u.id} className={`mover-card ${i === 0 ? "mover-top" : ""}`} style={{ animationDelay: `${i * 70}ms` }}>
            <div className="mover-top-row">
              <div className="mover-avatar" style={{ background: u.name === "You" ? "var(--garnet)" : `hsl(${u.id * 47}, 55%, 52%)` }}>
                {u.initials}
              </div>
              <div className="mover-info">
                <span className="mover-name">{u.name}</span>
                <RankChange curr={u.rank} prev={u.prev} />
              </div>
              {i === 0 && <div className="mover-crown"><IconCrown /></div>}
            </div>
            <div className="mover-growth">
              <div className="growth-num" style={{ color: "#10b981" }}>+{u.growth}%</div>
              <div className="growth-bar-track">
                <div className="growth-bar-fill" style={{ width: `${Math.min(u.growth * 4, 100)}%` }} />
              </div>
            </div>
            <div className="mover-footer">
              <span className="mover-xp">+{u.weeklyXP.toLocaleString()} XP this week</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

// ─── Profile Insight View ─────────────────────────────────────────────────────

function ProfileInsightView() {
  const xpPercent = Math.round(((ME.xp - ME.currentRankXP) / (ME.nextRankXP - ME.currentRankXP)) * 100);
  const [barW, setBarW] = useState(0);
  useEffect(() => {
    const t = setTimeout(() => setBarW(xpPercent), 300);
    return () => clearTimeout(t);
  }, [xpPercent]);

  const aiInsights = [
    { icon: IconTarget,  text: "You are ranked higher due to consistency in assignments", type: "positive" },
    { icon: IconBrain,   text: "Improve React assignments to reach top 10%",               type: "action"   },
    { icon: IconTrendUp, text: "You may reach top 15% in 7 days at this pace",             type: "predict"  },
    { icon: IconFlame,   text: "Your 16-day streak boosts your visibility score by 22%",   type: "positive" },
  ];

  return (
    <div className="profile-view">
      <div className="profile-left">
        <div className="profile-header-card">
          <div className="ph-avatar">{ME.initials}</div>
          <div className="ph-info">
            <span className="ph-name">{ME.name}</span>
            <span className="ph-rank">Rank #{ME.rank} globally</span>
            <div className="ph-badges">{ME.badges.map(b => <Badge key={b} label={b} />)}</div>
          </div>
          <div className="ph-streak"><IconFlame /><span>{ME.streak}d</span></div>
        </div>

        <div className="xp-progress-card">
          <div className="xpc-header">
            <span className="xpc-label">XP Progress to Rank #{ME.rank - 1}</span>
            <span className="xpc-vals">{ME.xp.toLocaleString()} / {ME.nextRankXP.toLocaleString()}</span>
          </div>
          <div className="xp-bar-track">
            <div className="xp-bar-fill" style={{ width: `${barW}%`, transition: "width 1.2s cubic-bezier(.4,0,.2,1)" }} />
            <div className="xp-bar-marker" style={{ left: `${barW}%` }} />
          </div>
          <div className="xpc-footer">
            <span>{xpPercent}% complete</span>
            <span>{(ME.nextRankXP - ME.xp).toLocaleString()} XP to next rank</span>
          </div>
        </div>

        <div className="skill-breakdown-card">
          <div className="sbc-title">Skill Breakdown</div>
          {SKILL_KEYS.map((sk, i) => (
            <SkillBar key={sk} label={SKILLS[i]} value={ME.skills[sk]} color={SKILL_COLORS[i]} />
          ))}
        </div>
      </div>

      <div className="profile-right">
        <div className="ai-insights-card">
          <div className="aic-title"><IconBrain />AI Performance Analysis</div>
          {aiInsights.map((ins, i) => (
            <div key={i} className={`ai-insight-item ${ins.type}`}>
              <div className="aii-icon"><ins.icon /></div>
              <p>{ins.text}</p>
            </div>
          ))}
        </div>

        <div className="stats-grid">
          <div className="stat-mini"><span className="sm-val">{ME.courses}</span><span className="sm-lbl">Courses</span></div>
          <div className="stat-mini"><span className="sm-val">{ME.assignments}</span><span className="sm-lbl">Tasks Done</span></div>
          <div className="stat-mini"><span className="sm-val">{ME.accuracy}%</span><span className="sm-lbl">Accuracy</span></div>
          <div className="stat-mini"><span className="sm-val">+{ME.growth}%</span><span className="sm-lbl">This Week</span></div>
        </div>

        <div className="streak-heatmap">
          <div className="sh-title">Activity — Last 10 Weeks</div>
          <div className="sh-grid">
            {Array.from({ length: 70 }).map((_, i) => {
              const intensity = Math.random();
              const active = Math.random() > 0.25;
              return (
                <div key={i} className="sh-cell" style={{
                  background: active ? `rgba(139,26,47,${0.15 + intensity * 0.85})` : "var(--bone-200)",
                  transform: active ? "scale(1)" : "scale(0.85)",
                }} />
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}

// ─── Tab Config ───────────────────────────────────────────────────────────────

const TABS = [
  { id: "global",  label: "Global Ranking",   Icon: IconTrophy   },
  { id: "skill",   label: "Skill-Based",       Icon: IconCode     },
  { id: "movers",  label: "Weekly Movers",     Icon: IconTrendUp  },
  { id: "profile", label: "Profile Insights",  Icon: IconTarget   },
];

// ─── Main Page ────────────────────────────────────────────────────────────────

export default function LeaderboardPage() {
  const [tab, setTab] = useState("global");

  return (
     <MyStudentLayout>
    <div>
      <div className="lb-root">
        <div className="lb-bg-pattern" />

        {/* Header */}
        <header className="lb-header">
          <div className="lb-header-brand">
            <div className="lh-icon"><IconTrophy /></div>
            <div>
              <h1 className="lh-title">Leaderboard</h1>
              <p className="lh-sub">Track top performers and measure your learning progress</p>
            </div>
          </div>
          <div className="kpi-row">
            <KPIWidget icon={IconTrophy}   label="Your Rank"     value={`#${ME.rank}`}      sub="Top 23%"           accent="#d4a017" />
            <KPIWidget icon={IconZap}      label="Total XP"      value={ME.xp}              sub="+1,240 this week"  accent="#8b5cf6" animate />
            <KPIWidget icon={IconTrendUp}  label="Weekly Growth" value={`+${ME.growth}%`}   sub="6 ranks gained"    accent="#10b981" />
            <KPIWidget icon={IconFlame}    label="Current Streak" value={`${ME.streak}d`}   sub="Personal best!"    accent="#f59e0b" />
          </div>
        </header>

        {/* Tab Bar */}
        <div className="lb-tabbar">
          {TABS.map(({ id, label, Icon }) => (
            <button key={id} className={`lb-tab ${tab === id ? "on" : ""}`} onClick={() => setTab(id)}>
              <Icon />
              {label}
            </button>
          ))}
        </div>

        {/* Content */}
        <main className="lb-content">
          {tab === "global"  && <GlobalRankingView />}
          {tab === "skill"   && <SkillRankingView />}
          {tab === "movers"  && <WeeklyMoversView />}
          {tab === "profile" && <ProfileInsightView />}
        </main>
      </div>
    </div>
    </MyStudentLayout>
  );
}